import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DocViewerManagerComponent, UtilsService } from '@dabnet-kamu/libs/ui';
import { DysService } from '../services/dys.service';
import { UstYaziService } from './ust-yazi.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'dk-ust-yazi-popup',
  standalone: true,
  imports: [CommonModule,DocViewerManagerComponent],
  templateUrl: './ust-yazi-popup.component.html',
  styleUrls: ['./ust-yazi-popup.component.scss'],
})
export class UstYaziPopupComponent implements OnInit, OnDestroy {
  @Input() belgeKod: number;
  /** DKM-5139 Cedric: true ise içerik BYS_GetDocumentUstYaziOnIzleme ile (Word → PDF önizleme) alınır; taslak giden belgeler için. Varsayılan false, diğer kullanımlar değişmez. */
  @Input() onIzleme = false;
  isFileImage: boolean;
  documentLoad = false;
  fileUrl: SafeResourceUrl;
  failedDocLoadMsg = 'Belge Seçiniz';
  public base64Src: string;
  docId:number;
  private destroy$ = new Subject<void>();
  constructor(
    public service: UstYaziService,
    private utilService: UtilsService,
    public sanitizer: DomSanitizer,
    private dysService: DysService
  ) {}

  ngOnInit(): void {

  // DKM-5139 Cedric: eski hâli (taslak giden belgede servis "henüz üst yazısı yok" döndürüyordu)
  // this.service.getUstYazi(this.belgeKod,'H').pipe(takeUntil(this.destroy$)).subscribe(res=>{
  const istek$ = this.onIzleme ? this.service.getUstYaziOnIzleme(this.belgeKod,'H') : this.service.getUstYazi(this.belgeKod,'H');
  istek$.pipe(takeUntil(this.destroy$)).subscribe(res=>{
    if(res.result){
      this.docId=Number(res.dysKod);
      this.base64Src = res.dysContent;
      this.base64Change();
    }
    else{
      this.utilService.showError(res.errorMessage,"Üst Yazı Hata")
    }
  })
  }


  base64Change(){
    if(this.base64Src){
      let content = this.base64Src?.split('base64,').pop();
      const byteCharacters = atob(content);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf'});
    const url = URL.createObjectURL(blob);
    this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.documentLoad = true;
    }
  }

  onFileError() {
    this.documentLoad = false;
  }

  onDocumentLoad() {
    this.documentLoad = true;
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete()
  }
}
